import { useEffect } from 'react'

/** Warms the ApplicationContainer chunk while the user is still on signed-up,
 *  so the Suspense fallback in Router.tsx resolves instantly once they land on /application-test. */
export const usePreloadApplicationContainer = (shouldPreload: boolean) => {
    useEffect(() => {
        if (!shouldPreload) return

        import('./ApplicationContainer')
    }, [shouldPreload])
}
